<template>
	<div
		class="person"
		:class="{ 'no-image': !image }"
		@mouseover="show = true"
		@mouseleave="show = false"
	>
		<img :src="image" :alt="full_name" />
		<transition name="fade">
			<div class="content" :class='team_tile_type' v-if="show">
				<div class="name-and-position">
					<h4
						v-if="full_name"
						v-html="full_name + ' -'"
						data-aos="fade-right"
						data-aos-delay="50"
					></h4>
					<h4
						v-if="position"
						class="position"
						v-html="position"
						data-aos="fade-right"
						data-aos-delay="100"
					></h4>
				</div>
				<p
					v-if="excerpt"
					class="bio"
					v-html="excerpt"
					data-aos="fade-right"
					data-aos-delay="150"
				></p>
				<a
					v-if="phone && team_tile_type === 'type_b'"
					class="phone"
					:href="`tel:${phone}`"
					v-html="phone"
					target="_blank"
					data-aos="fade-right"
					data-aos-delay="200"
				></a>

				<a
					v-if="email && team_tile_type === 'type_b'"
					class="email"
					:href="`mailto:${email}`"
					v-html="email"
					target="_blank"
					data-aos="fade-right"
					data-aos-delay="200"
				></a>

				<a
					v-if="linkedin && (team_tile_type === 'type_a' || team_tile_type === 'type_b' || team_tile_type === null)"
					class="linkedin"
					:href="linkedin"
					target="_blank"
					data-aos="fade-right"
					data-aos-delay="200"
				>
					<svg
						width="56"
						height="56"
						viewBox="0 0 56 56"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle cx="28" cy="28" r="28" fill="#53628B" />
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M34.09 17C36.26 17 38.03 18.76 38.03 20.94V34.09C38.03 36.26 36.27 38.03 34.09 38.03H20.94C18.77 38.03 17 36.27 17 34.09V20.94C17 18.77 18.76 17 20.94 17H34.09ZM31.62 29.53V34.61H34.77V29.16C34.77 26.25 33.21 24.89 31.13 24.89C29.4707 24.89 28.7164 25.7856 28.3 26.4422V25.11H25.13C25.13 25.11 25.17 26 25.13 34.61H28.3V29.3C28.3 29.02 28.32 28.73 28.4 28.53C28.63 27.97 29.15 27.38 30.03 27.38C31.17 27.38 31.62 28.24 31.62 29.53ZM28.3 26.4422C28.2898 26.4582 28.2798 26.4742 28.27 26.49H28.3V26.4422ZM21.81 23.81C22.93 23.81 23.61 23.07 23.61 22.17H23.62C23.6 21.24 22.94 20.53 21.85 20.53C20.76 20.53 20.05 21.27 20.05 22.17C20.05 23.07 20.73 23.81 21.8 23.81H21.81ZM23.42 25.1H20.25V34.61H23.42V25.1Z"
							fill="white"
						/>
					</svg>
				</a>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		image: {},
		full_name: {},
		position: {},
		bio: {},
		excerpt: {},
		phone: {},
		email: {},
		linkedin: {},
		team_tile_type: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.person {
	display: flex;
	align-items: flex-start;
	gap: 24px;
	grid-column: span 4;
	border-top: 1px solid var(--fpe-light-grey);
	position: relative;
	overflow: hidden;
	aspect-ratio: 3 / 3.5;
	border-radius: 30px;
	overflow: hidden;

	@media (max-width: $mobile-xl) {
		grid-column: span 4;
	}

	@media (max-width: $mobile) {
		grid-column: span 4;
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center top;
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		position: absolute;
		top: 0;
		left: 0;
		width: calc(100% - 100px);
		height: calc(100% - 100px);
		gap: 24px;
		z-index: 10;
		background: var(--fpe-mid-grey);
		border-radius: 30px;
		padding: 50px 50px;
		overflow: hidden;

		&.type_b {
			justify-content: center;
		}

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
		}

		h4,
		h5 {
			margin: 0 0 5px;
			font: normal normal 300 22px/22px var(--primary-font-family);
			color: var(--fpe-dark-blue);
			text-transform: capitalize;
		}

		p {
			margin: 0;

			&.position {
				font: normal normal 300 16px/24px var(--primary-font-family);
				color: var(--fpe-blue);
			}

			&.bio {
				font: normal normal 300 16px/24px var(--primary-font-family);
				color: var(--fpe-blue);
				margin: 0 0 0;
				opacity: 0.7;
				/* display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				overflow: hidden; */
			}
		}

		a {
			height: auto;
			margin-bottom: 0;

			@media (max-width: $mobile-xl) {
				margin-bottom: 8px;
			}

			&:last-of-type {
				margin-bottom: 0;
			}

			&.phone {
				font: normal normal 300 16px/24px var(--primary-font-family);
				color: var(--fpe-blue);
				text-decoration: none;
			}

			&.email {
				font: normal normal 300 16px/24px var(--primary-font-family);
				color: var(--fpe-blue);
			}

			&.linkedin {
				font: normal normal 300 16px/24px var(--primary-font-family);
				color: var(--fpe-blue);
			}

			position: relative;
			padding-left: 16px;
			text-decoration: underline;
			display: flex;
			font: normal normal 300 16px/24px var(--primary-font-family);
			color: var(--fpe-blue);
			align-items: center;

			&:hover {
				text-decoration: underline;
			}

			&[href^='mailto:'] {
				padding: 0;
				border-right: 0;
				border: none;
				position: relative;
				display: flex;
				align-items: center;
				gap: 12px;
				border-bottom: 1px solid var(--fpe-blue);
				font: normal normal 300 14px/18px var(--primary-font-family);
				color: var(--fpe-blue);
				text-decoration: none;

				&::before {
					content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODM0Njk3IDEwTDAgOS4xNzg5OEw2Ljg1NzYxIDIuMjgyNDNMMi4zMDc2OSAxLjIxNTExTDIuNTY5NTYgMEw4LjUxMDY0IDEuNDYxNDFMMTAgNy41MDQxMUw4Ljc3MjUgNy43ODMyNUw3LjY5MjMxIDMuMTE5ODdMMC44MzQ2OTcgMTBaIiBmaWxsPSIjNTM2MjhCIi8+Cjwvc3ZnPgo=');
					display: block;
					/* width: 6.11px;
                height: 6.09px;
                background: var(--cobalt); */
				}
			}

			&[href^='tel:'] {
				padding-left: 32px;

				&::before {
					width: 32px;
					height: auto;
					border-radius: none;
					background: none;
					display: block;
					content: 'M+';
					position: absolute;
					left: 0;
					margin-right: 10px;
				}
			}

			&.linkedin {
				padding-left: 0;

				/* &::before {
					width: 32px;
					height: auto;
					border-radius: none;
					background: none;
					display: block;
					content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBpZD0iSWNvbl9hd2Vzb21lLWxpbmtlZGluLWluIiBkYXRhLW5hbWU9Ikljb24gYXdlc29tZS1saW5rZWRpbi1pbiIgZD0iTTMuNTgxLDE2SC4yNjRWNS4zMThIMy41ODFaTTEuOTIxLDMuODYxQTEuOTMsMS45MywwLDEsMSwzLjg0MiwxLjkyMiwxLjkzNywxLjkzNywwLDAsMSwxLjkyMSwzLjg2MVpNMTYsMTZoLTMuMzFWMTAuOGMwLTEuMjM5LS4wMjUtMi44MjktMS43MjUtMi44MjktMS43MjUsMC0xLjk4OSwxLjM0Ni0xLjk4OSwyLjczOVYxNkg1LjY1OVY1LjMxOEg4Ljg0MVY2Ljc3NWguMDQ2QTMuNDg2LDMuNDg2LDAsMCwxLDEyLjAyNiw1LjA1QzE1LjM4Myw1LjA1LDE2LDcuMjYxLDE2LDEwLjEzMlYxNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTAuMDAxKSIgZmlsbD0iIzAwMzc2NCIvPgo8L3N2Zz4K');
					position: absolute;
					left: 0;
					margin-right: 10px;
				} */
			}
		}
	}
}

/* .fade-enter-active,
.fade-leave-active {
	transition: all 0.2s;
	transform: translateX(0);
}
.fade-enter-from, .fade-leave-to {
	opacity: 0;
	transform: translateX(-100%);
} */

.fade-enter-active {
	animation: fade-in 0.3s;
}
.fade-leave-active {
	animation: fade-in 0.3s reverse;
}
@keyframes fade-in {
	0% {
		opacity: 0;
		transform: translateX(-100%);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PersonTile.vue